module.exports = __webpack_public_path__ + "img/1536278769.93180151.jpg";